import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const CloseRemoveIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
    >
      <g id="Icon">
        <path
          id="Vector"
          d="M5.90846 5.81593L5.90846 5.81593L11.1593 11.2856L11.52 11.6613L11.8807 11.2856L17.1316 5.81594C17.216 5.72802 17.344 5.72802 17.4284 5.81594C17.5239 5.91535 17.5239 6.08465 17.4284 6.18406L17.4284 6.18406L12.1776 11.6537L11.8452 12L12.1776 12.3463L17.4284 17.816L17.7891 17.4697L17.4284 17.816C17.5239 17.9154 17.5239 18.0846 17.4284 18.184C17.344 18.272 17.216 18.272 17.1316 18.184L16.7709 18.5303L17.1316 18.184L11.8807 12.7144L11.52 12.3387L11.1593 12.7144L5.90846 18.184L5.90845 18.184C5.82406 18.272 5.69601 18.272 5.61162 18.184C5.51618 18.0846 5.51618 17.9154 5.61162 17.816L10.8625 12.3463L11.1949 12L10.8625 11.6537L5.61161 6.18406L5.61161 6.18406C5.51618 6.08465 5.51618 5.91534 5.61161 5.81593C5.69601 5.72802 5.82407 5.72802 5.90846 5.81593Z"
          fill={props.fill || "currentColor" || "#52565C"}
          stroke={props.fill || "currentColor" || "#52565C"}
        />
      </g>
    </svg>
  );
};

export default CloseRemoveIcon;
